/**
 * API de auditoría (Herramientas Administrativas).
 * Solo lectura; requiere X-Admin-Tools-Token.
 */
import { api } from "@/lib/apiClient";
import { getAdminToolsUnlockToken } from "@/lib/roles";

function adminToolsHeaders() {
  const unlock = getAdminToolsUnlockToken();
  const headers = {};
  if (unlock) headers["X-Admin-Tools-Token"] = unlock;
  return headers;
}

/**
 * @param {{
 *   limit?: number,
 *   skip?: number,
 *   username?: string,
 *   action?: string,
 *   entity_type?: string,
 *   date_from?: string,
 *   date_to?: string,
 * }} [params]
 */
export async function fetchAuditLogs(params = {}) {
  const res = await api.get("/import-export/admin-tools/audit-logs", {
    headers: adminToolsHeaders(),
    params: {
      limit: params.limit ?? 10,
      skip: params.skip ?? 0,
      username: params.username || undefined,
      action: params.action || undefined,
      entity_type: params.entity_type || undefined,
      date_from: params.date_from || undefined,
      date_to: params.date_to || undefined,
    },
  });
  return res.data;
}

export const AUDIT_ACTION_OPTIONS = [
  { value: "", label: "Todas las acciones" },
  { value: "created", label: "Creó" },
  { value: "updated", label: "Modificó" },
  { value: "deleted", label: "Eliminó" },
  { value: "restored", label: "Restauró" },
];

export const AUDIT_ENTITY_OPTIONS = [
  { value: "", label: "Todos los tipos" },
  { value: "member", label: "Miembro" },
  { value: "cell", label: "Célula" },
  { value: "guest", label: "Invitado" },
  { value: "attendance", label: "Asistencia" },
  { value: "report", label: "Informe" },
  { value: "backup", label: "Respaldo" },
  { value: "other", label: "Otro" },
];

export function formatAuditDateTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  try {
    const date = d.toLocaleDateString("es-MX", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
    const time = d.toLocaleTimeString("es-MX", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
    return `${date} ${time}`;
  } catch {
    return String(iso);
  }
}
